/**
 * 把一份 Blob 交给浏览器存盘（UI 规范 §3.2 `/ledger` 的 `导出 CSV`）。
 *
 * ## 为什么不是 `window.open(url)`
 *
 * 那条路径由**浏览器**重新发起请求，应用的鉴权头注入点（`lib/apiClient.ts` →
 * `packages/api-client/src/client.ts:107-114`）根本不会执行 ⇒ 服务端看到的是一次
 * 无 `Authorization` 的请求（401），用户看到的是一个空白页。硬要求 6 因此明令禁止它。
 *
 * ## 为什么在 0ms 定时器里回收
 *
 * 同步 `revokeObjectURL` 会让部分浏览器还没来得及开始读这个 blob URL 就把它失效
 * （下载静默失败）。放到下一个宏任务里既能让 `click()` 先落地，也不会把 URL 留成泄漏。
 */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 0);
}
